<template>
  <div>
    <v-row class="pa-0 ma-0" v-if="mapDetails">
      <v-col
        v-for="(value, key, index) of mapDetails.orders_state"
        :key="index"
        class="pa-2 mt-1"
        :class="
          index &&
          mapDetails &&
          Object.keys(mapDetails.orders_state).length - 1 == index
            ? 'pr-0'
            : index == 0
            ? 'pl-0'
            : ''
        "
      >
        <v-card class="px-5 py-3 rounded-lg mb-1" elevation="0" tile>
          <v-card-title class="d-flex justify-start pa-0">
            <span
              class="text-capitalize text-center text-caption"
              style="white-space: nowrap"
            >
              {{ key.replace(/_/g, "  ") }}
            </span>
          </v-card-title>
          <v-card-text class="d-flex justify-start pa-0">
            <v-btn small class="h-100 btn-box display-lg-none mr-3" depressed>
              <v-icon :color="getOrderStatusColor(key, true)" small>
                mdi-archive
              </v-icon>
            </v-btn>
            <h2 class="font-weight-bold d-flex align-center">
              {{ value }}
            </h2>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" class="pa-2 white rounded-lg">
        <GoogleMap
          id="customerLocationAddress"
          mapHeight="calc(100vh - 265px)"
          ref="operationsViewTrip"
          :clusterMarkers="true"
          :hasMapInfo="true"
        >
          <template #mapInfo>
            <MapInfo legendType="operations" />
          </template>
        </GoogleMap>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { bus } from "@/main.js";
import { getOrderStatusColor } from "@/utils/functions";
import GoogleMap from "@/components/BaseComponents/GoogleMap.vue";
import { returnToday } from "@/utils/functions";
import MapInfo from "@/components/BaseComponents/MapInfo.vue";

export default {
  props: {
    filters: {
      type: Object,
      default: {},
    },
    tabs: {
      type: Number,
    },
  },
  components: {
    GoogleMap,
    MapInfo,
  },
  data() {
    return {
      getOrderStatusColor,
      mapDetails: {},
      todayDate: returnToday(),
    };
  },
  watch: {
    filters: {
      handler(newValue, oldValue) {
        this.getMapInfo();
      },
      deep: true,
    },
    tabs(val) {
      if (val == 0) {
        this.getMapInfo();
      }
    },
  },
  methods: {
    getMapInfo(params = {}) {
      // this.$refs.operationsViewTrip.clearGeoJson();
      params = {
        ...params,
        ...this.filters,
      };
      bus.$emit("showLoader", true);
      this.$api.newOperation
        .getMapInfo(params)
        .then((res) => {
          bus.$emit("showLoader", false);
          this.mapDetails = res.data;
          // this.$refs.mapinfo.operationsMapInfo(res?.data?.trips_state);

          let driverList = res?.data?.driver_location.map((item) => {
            // if (item?.driver_details?.trip_status == "active") {
            //   item.type = item?.driver_details?.connection_lost
            //     ? "operationsActiveConnectionLost"
            //     : "operationsActive";
            // } else if (item?.driver_details?.trip_status == "loading") {
            //   item.type = item?.driver_details?.connection_lost
            //     ? "operationsLoadingConnectionLost"
            //     : "operationsLoading";
            // } else if (
            //   item?.driver_details?.trip_status == "loading_completed"
            // ) {
            //   item.type = item?.driver_details?.connection_lost
            //     ? "operationsLoadingCompletedConnectionLost"
            //     : "operationsLoadingCompleted";
            // } else if (item?.driver_details?.trip_status == "paused") {
            //   item.type = item?.driver_details?.connection_lost
            //     ? "operationsPausedConnectionLost"
            //     : "operationsPaused";
            // } else {
            //   item.type = "operationsActiveConnectionLost";
            // }
            item.type = "driver";

            return item;
          });
          this.$refs.operationsViewTrip.initMap();
          setTimeout(() => {
            this.$refs.operationsViewTrip.loadDrivers(driverList);
          }, 100);
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },
  },
  mounted() {
    this.getMapInfo();
  },
};
</script>

<style>
</style>